import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { UpdateCaseAssigneesCommand } from './update-case-assignees.command';

/**
 * Update case assignees use case.
 * Updates primary and secondary assignees for a case.
 */
@Injectable({ providedIn: 'root' })
export class UpdateCaseAssigneesUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  /**
   * Executes the update case assignees use case.
   * @param command - The command containing case ID and assignee IDs
   * @returns Observable void
   */
  public execute(command: UpdateCaseAssigneesCommand): Observable<void> {
    this._state.setSavingCases(true);
    this._state.setErrorCases(null);

    return this._repository
      .updateCaseAssignees(command.caseId, command.primaryAssigneeUserId, command.secondaryAssigneeUserId)
      .pipe(
        tap(() => {
          this._state.setSavingCases(false);
        }),
        catchError((error) => {
          this._state.setErrorCases(error.message || 'Failed to update case assignees');
          this._state.setSavingCases(false);
          return throwError(() => error);
        })
      );
  }
}
